export default "__VITE_ASSET__CCbuVB5B__"